enum GPTFunctions {
    getResume = 'get_candidate_resume',
    getJobs = 'get_top_jobs',
}

export default GPTFunctions;